

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BillServiceWiseReportParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface BillServiceWiseReport {

  fromDate: any;
  toDate: string;
  ServiceCategoryId: string;
   
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: BillServiceWiseReportParameter[];
    links?: any;
}

export abstract class BillServiceWiseReportData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<BillServiceWiseReport[]>;
  abstract create(url: string,data: BillServiceWiseReport): Observable<any>;
  abstract update(url: string,data: BillServiceWiseReport): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchList(url: string, data:any): Observable<any>;
}
